import ApiHelper from "./ApiHelper"

export const CongNoApi = {
    GetCongNoTongHop: async () => {        
        let result = await ApiHelper.get(`congno/getCongNoTongHop` )
        return result.data
    },
    GetTempleteNhapChungTu: async (payload ) => {        
        const {contactId} = payload
        let result = await ApiHelper.get(`congno/getTempleteNhapChungTu?contactId=${contactId}` )
        return result.data
    },
    SaveChungTu: async (payload) => {        
        let result = await ApiHelper.post(`congno/saveChungTuRest`,payload )
        return result.data
    },
    GetCongNoChiTiet: async (payload) => {        
        const {contactId,tuNgay,denNgay} = payload
        let result = await ApiHelper.get(`congno/getCongNoChiTietRest?contactId=${contactId}`+
            `&tuNgay=${tuNgay}&denNgay=${denNgay}`
         )
        return result.data
    },
    DeleteChungTu: async (payload) => {        
        const {chungTuId} = payload
        let result = await ApiHelper.delete(`congno/deleteChungTuRest?chungTuId=${chungTuId}`
         )
        return result.data
    },
}